module.exports = __webpack_public_path__ + "static/media/medocs_04_thumb_hover.a38e78ce.png";